@if (!editMode) {
  <div class="sample-detail-wrapper">
    <div class="title-wrapper">
      <div class="title">{{ 'member_sample_detail_sample_data_title' | translate }}</div>
    </div>
    <div class="row display-row">
      <div class="col-6">
        <div class="display-content">
          <div class="display-label">{{ 'member_sample_detail_sample_data_date' | translate }}</div>
          <div class="display-value">
            {{ sample.sampleDate | localizedDate: 'dd MMMM yyyy' }}
          </div>
        </div>
      </div>
      @if (!isRMO) {
        <div class="col-6">
          <div class="display-content">
            <div class="display-label">{{ 'member_sample_detail_sample_data_supplier_number' | translate }}</div>
            <div class="display-value">
              {{ sample.deliveryNr ?? '-' }}
            </div>
          </div>
        </div>
      }
    </div>
    @if (isRMO) {
      <div class="row display-row">
        <div class="col-6">
          <div class="display-content">
            <div class="display-label">{{ 'member_sample_detail_sample_data_trip_number' | translate }}</div>
            <div class="display-value">
              {{ sample.rideNr ?? '-' }}
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="display-content">
            <div class="display-label">{{ 'member_sample_detail_sample_data_identification_rmo' | translate }}</div>
            <div class="display-value">
              {{ sample.identificationNr ?? '-' }}
            </div>
          </div>
        </div>
      </div>
    }
    <div class="row display-row">
      <div class="col-6">
        <div class="display-content">
          <div class="display-label">{{ 'member_sample_detail_sample_data_buyer' | translate }}</div>
          <div class="display-value">
            {{ sample.buyerId | sampleBuyer: buyersOptions }}
          </div>
        </div>
      </div>
      @if (isRMO) {
        <div class="col-6">
          <div class="display-content">
            <div class="display-label">{{ 'member_sample_detail_sample_data_office' | translate }}</div>
            <div class="display-value">
              {{ sample.warehouseId | sampleWarehouse: warehouseOptions }}
            </div>
          </div>
        </div>
      }
    </div>
    <div class="row display-row">
      <div class="col-6">
        <div class="display-content">
          <div class="display-label">{{ 'member_sample_detail_sample_data_province' | translate }}</div>
          <div class="display-value">
            {{ sample.provinceId | sampleProvince: provinceOptions }}
          </div>
        </div>
      </div>
    </div>
  </div>
}
@if (editMode) {
  <div class="sample-data">
    <div class="title">{{ 'member_sample_detail_sample_data_title' | translate }}</div>
    <div class="sub-title">{{ 'member_sample_detail_sample_data_sub_title' | translate }}</div>
    <div class="sample-data-form">
      <div class="row display-row display-row--form">
        <div class="col-2">
          <app-field-date
            [error]="sampleDataError.sampleDate"
            [label]="'member_sample_detail_sample_data_date' | translate"
            [model]="sampleDataForm.sampleDate"
            [placeholder]="'member_sample_detail_sample_data_date_placeholder' | translate"
            (modelChange)="onFormChange('sampleDate', $event)"
          ></app-field-date>
        </div>
      </div>
      @if (!isRMO) {
        <div class="row display-row display-row--form">
          <div class="col-2">
            <app-field-text
              [error]="sampleDataError.deliveryNr"
              [label]="'member_sample_detail_sample_data_supplier_number' | translate"
              [model]="sampleDataForm.deliveryNr"
              (modelChange)="onFormChange('deliveryNr', $event)"
            ></app-field-text>
          </div>
        </div>
      }
      @if (isRMO) {
        <div class="row display-row display-row--form">
          <div class="col-3">
            <app-field-text
              [error]="sampleDataError.rideNr"
              [label]="'member_sample_detail_sample_data_trip_number' | translate"
              [model]="sampleDataForm.rideNr"
              (modelChange)="onFormChange('rideNr', $event)"
            ></app-field-text>
          </div>
        </div>
      }
      @if (isRMO) {
        <div class="row display-row display-row--form">
          <div class="col-3">
            <app-field-text
              [optionalString]="'optional' | translate"
              [label]="'member_sample_detail_sample_data_identification_rmo' | translate"
              [model]="sampleDataForm.identificationNr"
              (modelChange)="onFormChange('identificationNr', $event)"
            ></app-field-text>
          </div>
        </div>
      }
      <div class="row display-row display-row--form">
        @if (!sampleDataForm?.fix_buyer) {
          <div class="col-3">
            <app-field-select
              [error]="sampleDataError.buyerId"
              [label]="'member_sample_detail_sample_data_buyer' | translate"
              [model]="sampleDataForm.buyerId"
              [options]="buyersOptions"
              [placeholder]="'member_dropdown_placeholder' | translate"
              (modelChange)="onFormChange('buyerId', $event)"
            ></app-field-select>
          </div>
        }
        @if (sampleDataForm?.fix_buyer?.id) {
          <div class="col-3">
            <div class="display-label">{{ 'member_sample_detail_sample_data_buyer' | translate }}</div>
            <div class="display-value">
              {{ sampleDataForm.fix_buyer.name }}
            </div>
          </div>
        }
        @if (isRMO && warehouseOptions) {
          <div class="col-3">
            <app-field-select
              [error]="sampleDataError.warehouseId"
              [label]="'member_sample_detail_sample_data_office' | translate"
              [model]="sampleDataForm.warehouseId"
              [options]="warehouseOptions"
              [placeholder]="'member_dropdown_placeholder' | translate"
              (modelChange)="onFormChange('warehouseId', $event)"
            ></app-field-select>
          </div>
        }
      </div>
      <div class="row display-row display-row--form">
        <div class="col-3">
          <app-field-select
            [error]="sampleDataError.provinceId"
            [label]="'member_sample_detail_sample_data_province' | translate"
            [model]="sampleDataForm.provinceId"
            [options]="provinceOptions"
            [placeholder]="'member_dropdown_placeholder' | translate"
            (modelChange)="onFormChange('provinceId', $event)"
          ></app-field-select>
        </div>
      </div>
    </div>
    <div class="divider"></div>
    @if (errorMessage) {
      <div class="error">
        {{ errorMessage }}
      </div>
    }
    <div class="buttons-wrapper">
      <app-button
        classes="primary-default"
        text="{{ 'save' | translate }}"
        icon="check-round-filled"
        [submitting]="loading"
        (emitClick)="onSaveSampleData()"
      ></app-button>
      <p class="link" (click)="onDismiss()">{{ 'cancel' | translate }}</p>
    </div>
  </div>
}
